// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceView_root__2Ftky"};